import React from "react";
import { Outlet } from "react-router-dom";

const WhiteLabelWrapper: React.FC = () => {
  return (
    <div className="white-label-wrapper">
      <Outlet />
    </div>
  );
};

export default WhiteLabelWrapper;
